import { useSelector } from 'react-redux'
import userSelectors from '../../store/selectors/user.selectors'

const useAuthorization = (roles = []) => {
    const user = useSelector(userSelectors.user) || {}
    const loading = useSelector(userSelectors.isWaitingForGetCurrentUser)

    let userRoles = user.roles || []

    const isLoggedIn = Boolean(user && Object.keys(user).length)
    const hasRequiredRole = roles.length === 0 || (user && roles.some(role => userRoles.includes(role)))

    const isAuthorized = isLoggedIn && hasRequiredRole

    return { isAuthorized, isLoggedIn, loading }
}

export default useAuthorization
